import { Badge } from 'DesignSystem/ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'DesignSystem/ui/tooltip';

import { useEventDetails } from '../event-detail.route';
import { EVENT_SEVERITY_EXPLANATION, EVENT_SEVERITY_NAME, EventSeverity } from '../types';

export default function EventSeverityBadge() {
  const data = useEventDetails();
  const event = data?.event;

  if (!event) {
    return null;
  }

  switch (event.severity) {
    case EventSeverity.LOW:
      return (
        <BadgeWithTooltip severity={event.severity}>
          <Badge variant="secondary" className="cursor-default">
            Low
          </Badge>
        </BadgeWithTooltip>
      );
    case EventSeverity.MODERATE:
      return (
        <BadgeWithTooltip severity={event.severity}>
          <Badge variant="yellow" className="cursor-default text-red-950">
            Moderate
          </Badge>
        </BadgeWithTooltip>
      );
    case EventSeverity.MAJOR:
      return (
        <BadgeWithTooltip severity={event.severity}>
          <Badge variant="warningMuted" className="cursor-default">
            Major
          </Badge>
        </BadgeWithTooltip>
      );
    case EventSeverity.CRITICAL:
      return (
        <BadgeWithTooltip severity={event.severity}>
          <Badge variant="destructiveMuted" className="cursor-default">
            Critical
          </Badge>
        </BadgeWithTooltip>
      );
    default:
      return null;
  }
}

function BadgeWithTooltip({ children, severity }: { children: React.ReactNode; severity: EventSeverity }) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent className="flex w-[300px] flex-col gap-1 text-wrap p-2">
          <div className="type-body-xs pl-1 pt-1 font-medium">{EVENT_SEVERITY_NAME[severity]}</div>
          <div className="type-body-2xs pl-1 font-medium leading-normal">{EVENT_SEVERITY_EXPLANATION[severity]}</div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
